/* Defer a Swiper init until its container nears the viewport (300px margin).
   Falls back to immediate init when IntersectionObserver is unavailable. */
function initNearView(el, init) {
  if (!el) return;
  if (!('IntersectionObserver' in window)) { init(); return; }
  var io = new IntersectionObserver(function (entries) {
    if (entries[0].isIntersecting) { io.disconnect(); init(); }
  }, { rootMargin: '300px 0px' });
  io.observe(el);
}

jQuery(document).ready(function($){

    var productOOS = true;


     // trigger the play button click
    $('.fon-video-play').trigger('click');

    // wait a bit so player starts, then mute it
    setTimeout(function(){
        const player = document.querySelector('.product-main-gallery mux-player');
        if (player){
        player.muted = true;
        }
    }, 500);

    $(document).on('click', '.product-main-gallery .fon-video-lazy-container mux-player', function () {
        const player = this;  // the clicked mux-player

        // Toggle mute
        player.muted = !player.muted;
        player.currentTime = 0;
        // Optional: restart from beginning if you want
        // player.currentTime = 0;

        // Play the video (user click allows autoplay)
        player.play?.().catch(() => {});
        const $container = $(this).closest('.fon-video-lazy-container');
        
        $container.addClass('playing');
    });


    // setInteval(function(){

    //     $('.gift-product__card.gift-product__card--active').find('.per-day').html();

    // },1000);

    function checkPerDay(){
        var perDay = $('.gift-product__card.gift-product__card--active').find('.per-day').html();
        $('.per-day-dynamic').html(perDay);
        $('.per-day-dynamic-wrapper').addClass('active');
    }
   

    $('#try-onelife').on('click', function(e) {
      e.preventDefault(); // Prevent default link behavior

      $.magnificPopup.close();

      // Scroll smoothly to #gift-product
      $('html, body').animate({
          scrollTop: $('#gift-product').offset().top
      }, 600); // 600ms scroll duration
  });

    // Fisher-Yates shuffle function
    function shuffleArray(array) {
        for (let i = array.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [array[i], array[j]] = [array[j], array[i]];
        }
        return array;
    }

    // Loop over each slider
    $('.swiper-gift-card-reviews-slider').each(function (index, slider) {
        const $slider = $(slider);
        const $wrapper = $slider.find('.swiper-wrapper');
        const $slides = $wrapper.children().toArray();

        // Shuffle slides once before initializing Swiper
        shuffleArray($slides).forEach(slide => $wrapper.append(slide));

        // Initialize Swiper
        const swiperInstance = new Swiper(slider, {
            slidesPerView: 1,
            effect: 'fade',
            fadeEffect: { crossFade: true },
            loop: true,
            speed: 700,
            autoplay: { delay: 4000, disableOnInteraction: false },
            observeParents: true,
        });
    });

    $(document).on('click','.slide-up-footer button.slide-up-close',function(){
        $.magnificPopup.close();
    });


// Only activate swiper on mobile
if ($(window).width() <= 768) {

  // Wrap all cards in a swiper-wrapper dynamically
  $('.scientific-experts__grid').wrapInner('<div class="swiper-wrapper"></div>');

  // Add swiper-slide class to each card
  $('.scientific-experts__grid .scientific-experts__card').addClass('swiper-slide');

  // Add pagination container (optional)
  if ($('.scientific-experts__grid').find('.swiper-pagination').length === 0) {
    $('<div class="swiper-pagination"></div>').appendTo('.scientific-experts__grid');
  }

  // Initialize Swiper
  initNearView(document.querySelector('.scientific-experts__grid'), function () {
  var expertsSwiper = new Swiper('.scientific-experts__grid', {
    slidesPerView: 1.1,       // show part of next slide
    spaceBetween: 16,
    loop: true,                // make it loop infinitely
    grabCursor: true,
    autoplay: {                // add autoplay
      delay: 3000,             // 3 seconds per slide
      disableOnInteraction: false, // keep autoplay even after user interaction
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    }
  });
  });
}

    if ($('.country-GB').length){
        const swiperProductCarousel = new Swiper('.swiper-gift-product__carousel', {
            slidesPerView: 2,
            spaceBetween: 20,
            speed: 1600,
            grabCursor: true,
            centeredSlides: true,
            initialSlide: 0, // Start at 2nd slide
            breakpoints: {
                0: {              // phones
                slidesPerView: 2,
                spaceBetween: 10,
                },
            }
        });
        // Listen for slide change
        swiperProductCarousel.on('slideChange', function () {
            // Get the currently active slide
            const activeSlide = swiperProductCarousel.slides[swiperProductCarousel.activeIndex];
            
            // Get the data attribute
            const productData = activeSlide.getAttribute('data-fon-product');
            
            $('.gift-product__tabs > button').removeClass('gift-product__tab--active');
            $('.gift-product__tabs > button[data-tab="'+productData+'"]').addClass('gift-product__tab--active');


            $('.gift-product__card').removeClass('gift-product__card--active');
            $('.gift-product__card[data-tab="'+productData+'"]').addClass('gift-product__card--active');

            checkPerDay();
        });

        // When a tab is clicked
        $('.gift-product__tabs > button').on('click', function() {
            const tab = $(this).data('tab'); // Get the tab's data-tab

            // Find the index of the slide that matches this tab
            const targetIndex = swiperProductCarousel.slides.findIndex(slide => 
                slide.getAttribute('data-fon-product') === tab
            );

            if (targetIndex !== -1) {
                swiperProductCarousel.slideTo(targetIndex); // Slide to that slide
            }
            checkPerDay();
        });

    // When a gift product card is clicked
        $('.gift-product__card').on('click', function() {
            const $thisCard = $(this);             // The clicked card
            const tab = $thisCard.data('tab');     // Get the card's data-tab

            // Toggle active class
            $('.gift-product__card').removeClass('gift-product__card--active');
            $(`.gift-product__card[data-tab="${tab}"]`).addClass('gift-product__card--active');

            // Find the index of the slide that matches this tab
            const targetIndex = swiperProductCarousel.slides.findIndex(slide => 
                slide.getAttribute('data-fon-product') === tab
            );

            if (targetIndex !== -1) {
                swiperProductCarousel.slideTo(targetIndex); // Slide to that slide
            }

            // Scroll only on mobile screens
            if ($(window).width() < 768) {
            
                const cardOffsetTop = $thisCard.offset().top; // Distance from top of page
                $('html, body').animate({
                    scrollTop: cardOffsetTop - 100 // Scroll 100px above the card
                }, 500); // 500ms smooth scroll
            

                checkPerDay();
            }
        });
    }else{
        const swiperProductCarousel = new Swiper('.swiper-gift-product__carousel', {
            slidesPerView: 3,
            spaceBetween: 20,
            speed: 1600,
            grabCursor: true,
            centeredSlides: true,
            initialSlide: 1, // Start at 2nd slide
            breakpoints: {
                0: {              // phones
                slidesPerView: 3,
                spaceBetween: 10,
                },
            }
        });
        // Listen for slide change
        swiperProductCarousel.on('slideChange', function () {
            // Get the currently active slide
            const activeSlide = swiperProductCarousel.slides[swiperProductCarousel.activeIndex];
            
            // Get the data attribute
            const productData = activeSlide.getAttribute('data-fon-product');
            
            $('.gift-product__tabs > button').removeClass('gift-product__tab--active');
            $('.gift-product__tabs > button[data-tab="'+productData+'"]').addClass('gift-product__tab--active');


            $('.gift-product__card').removeClass('gift-product__card--active');
            $('.gift-product__card[data-tab="'+productData+'"]').addClass('gift-product__card--active');

            checkPerDay();
        });
        // When a tab is clicked
        $('.gift-product__tabs > button').on('click', function() {
            const tab = $(this).data('tab'); // Get the tab's data-tab

            // Find the index of the slide that matches this tab
            const targetIndex = swiperProductCarousel.slides.findIndex(slide => 
                slide.getAttribute('data-fon-product') === tab
            );

            if (targetIndex !== -1) {
                swiperProductCarousel.slideTo(targetIndex); // Slide to that slide
            }
            checkPerDay();
        });

    // When a gift product card is clicked
        $('.gift-product__card').on('click', function() {
            const $thisCard = $(this);             // The clicked card
            const tab = $thisCard.data('tab');     // Get the card's data-tab

            // Toggle active class
            $('.gift-product__card').removeClass('gift-product__card--active');
            $(`.gift-product__card[data-tab="${tab}"]`).addClass('gift-product__card--active');

            // Find the index of the slide that matches this tab
            const targetIndex = swiperProductCarousel.slides.findIndex(slide => 
                slide.getAttribute('data-fon-product') === tab
            );

            if (targetIndex !== -1) {
                swiperProductCarousel.slideTo(targetIndex); // Slide to that slide
            }

            // Scroll only on mobile screens
            if ($(window).width() < 768) {
            
                const cardOffsetTop = $thisCard.offset().top; // Distance from top of page
                $('html, body').animate({
                    scrollTop: cardOffsetTop - 100 // Scroll 100px above the card
                }, 500); // 500ms smooth scroll
            

                checkPerDay();
            }
        });
    }
    

    

    


    $(document).on('click','.gift-product__add-btn',function(){

        // March 31, 2026 OneLife OOS
        if (productOOS){
            showOutOfStockPopup('onelife'); // OneLife
            return;
        }


        var button = $(this);
        button.prop('disabled',true);
        
        var buttonTextEl = button.find('.gift-product__btn-text');
        var buttonTextValue = buttonTextEl.html();
        

        var parent = $(this).parents('.gift-product__card');
        var tab = parent.data('tab');

        switch (tab){
            case 'duo':

                buttonTextEl.html('Preparing Your Protocol...');

                var specialOfferVariantID = parseInt(button.attr('data-variant-id'));
                var specialOfferVariantSellingPlanID = parseInt(button.attr('data-selling-plan-id'));

                var formData = {
                items: [
                    {
                        id: specialOfferVariantID,
                        quantity: 6,
                        selling_plan: specialOfferVariantSellingPlanID,
                        properties : {
                            '_BUNDLE' : 'onelife_90d_duo',
                            '_bundle_group_id' : 'onelife_90d_duo',
                            "_bundle_group_product" : true,
                            "_bundle_group_product_row" : 1,
                            '_offer' : 'onelife_90d_duo',
                            '_offer_product_type' : 'primary',
                            '_order_from' : 'hybrid'
                        }
                    }
                ]
                };

                if (!bottleOOS) {
                    formData.items.push(
                        {
                            id: 53301741289656, // Free bottle variant ID
                            quantity: 2,
                            properties : {
                                '_offer' : 'onelife_90d_duo',
                                '_offer_product_type' : 'free',
                                '_order_from' : 'hybrid'
                            }
                        }
                    );
                }

                // if (!frotherOOS) {
                //     formData.items.push(
                //         {
                //             id: 52887363551416, // Free frother variant ID
                //             quantity: 2,
                //             properties : {
                //                 '_offer' : 'onelife_90d_duo',
                //                 '_offer_product_type' : 'free',
                //                 '_order_from' : 'hybrid'
                //             }
                //         }
                //     );
                // }

                
                // 1️⃣ Check cart first
                $.getJSON('/cart.js', function(cart) {
                    const hasItems = cart.item_count > 0;

                    // 2️⃣ Add to cart
                    $.ajax({
                        type: 'POST',
                        url: '/cart/add.js',
                        data: JSON.stringify(formData),
                        dataType: 'json',
                        contentType: 'application/json',
                        success: function () {
                            
                            setTimeout(function(){
                                    button.prop('disabled',false);
                                    buttonTextEl.html(buttonTextValue);
                            },2000);

                            if (typeof FonCartDrawer !== "undefined") {
            FonCartDrawer.openCartDrawer();
            FonCartDrawer.updateCartDrawer();
          }
                        },
                        error: function () {
                            button.prop('disabled',false);
                            buttonTextEl.html(buttonTextValue);
                            alert('Could not add item to cart. Please try again.');
                        }
                    });
                });
                // 1️⃣ Clear cart first
                // $.ajax({
                // type: 'POST',
                // url: '/cart/clear.js',
                //     success: function () {

                //         // 2️⃣ Add new items
                //         $.ajax({
                //         type: 'POST',
                //         url: '/cart/add.js',
                //         data: JSON.stringify(formData),
                //         dataType: 'json',
                //         contentType: 'application/json',
                //         success: function () {
                //             setTimeout(function(){
                //                 button.prop('disabled',false);
                //                 buttonTextEl.html(buttonTextValue);
                //             },2000);
                //             // 3️⃣ Redirect to checkout
                //             window.location.href = '/checkout';
                //         },
                //         error: function () {
                //             button.prop('disabled',false);
                //             buttonTextEl.html(buttonTextValue);
                //             alert('Could not add item to cart. Please try again.');
                //         }
                //         });

                //     },
                //     error: function () {
                //         button.prop('disabled',false);
                //         buttonTextEl.html(buttonTextValue);
                //         alert('Could not clear cart. Please try again.');
                //     }
                // });
            
            break;

            case 'single':

                buttonTextEl.html('Preparing Your Protocol...');

                var specialOfferVariantID = parseInt(button.attr('data-variant-id'));
                var specialOfferVariantSellingPlanID = parseInt(button.attr('data-selling-plan-id'));

                var formData = {
                items: [
                    {
                        id: specialOfferVariantID,
                        quantity: 3,
                        selling_plan: specialOfferVariantSellingPlanID,
                        properties : {
                            '_BUNDLE' : 'onelife_90d',
                            '_bundle_group_id' : 'onelife_90d',
                            "_bundle_group_product" : true,
                            "_bundle_group_product_row" : 1,
                            '_offer' : 'onelife_90d',
                            '_offer_product_type' : 'primary',
                            '_order_from' : 'hybrid'
                        }
                    }
                ]
                };

                if (!bottleOOS) {
                    formData.items.push(
                        {
                            id: 53301741289656, // Free bottle variant ID
                            quantity: 1,
                            properties : {
                                '_offer' : 'onelife_90d',
                                '_offer_product_type' : 'free',
                                '_order_from' : 'hybrid'
                            }
                        }
                    );
                }

                // if (!frotherOOS) {
                //     formData.items.push(
                //         {
                //             id: 52887363551416, // Free frother variant ID
                //             quantity: 1,
                //             properties : {
                //                 '_offer' : 'onelife_90d',
                //                 '_offer_product_type' : 'free',
                //                 '_order_from' : 'hybrid'
                //             }
                //         }
                //     );
                // }


                // 1️⃣ Clear cart first
                // $.ajax({
                // type: 'POST',
                // url: '/cart/clear.js',
                //     success: function () {

                //         // 2️⃣ Add new items
                //         $.ajax({
                //         type: 'POST',
                //         url: '/cart/add.js',
                //         data: JSON.stringify(formData),
                //         dataType: 'json',
                //         contentType: 'application/json',
                //         success: function () {
                //             setTimeout(function(){
                //                 button.prop('disabled',false);
                //                 buttonTextEl.html(buttonTextValue);
                //             },2000);
                //             // 3️⃣ Redirect to checkout
                //             window.location.href = '/checkout';
                //         },
                //         error: function () {
                //             button.prop('disabled',false);
                //             buttonTextEl.html(buttonTextValue);
                //             alert('Could not add item to cart. Please try again.');
                //         }
                //         });

                //     },
                //     error: function () {
                //         button.prop('disabled',false);
                //         buttonTextEl.html(buttonTextValue);
                //         alert('Could not clear cart. Please try again.');
                //     }
                // });

                // 1️⃣ Check cart first
                $.getJSON('/cart.js', function(cart) {
                    const hasItems = cart.item_count > 0;

                    // 2️⃣ Add to cart
                    $.ajax({
                        type: 'POST',
                        url: '/cart/add.js',
                        data: JSON.stringify(formData),
                        dataType: 'json',
                        contentType: 'application/json',
                        success: function () {
                            
                            setTimeout(function(){
                                    button.prop('disabled',false);
                                    buttonTextEl.html(buttonTextValue);
                            },2000);

                            if (typeof FonCartDrawer !== "undefined") {
            FonCartDrawer.openCartDrawer();
            FonCartDrawer.updateCartDrawer();
          }
                        },
                        error: function () {
                            button.prop('disabled',false);
                            buttonTextEl.html(buttonTextValue);
                            alert('Could not add item to cart. Please try again.');
                        }
                    });
                });
            
            break;

            case 'one-time':

                buttonTextEl.html('Preparing Your Protocol...');
                var specialOfferVariantID = parseInt(button.attr('data-variant-id'));

                var formData = {
                items: [
                    {
                        id: specialOfferVariantID,
                        quantity: 1,
                        properties : {
                            '_BUNDLE' : 'onelife_onetime',
                            '_bundle_group_id' : 'onelife_onetime',
                            "_bundle_group_product" : true,
                            "_bundle_group_product_row" : 1,
                            '_offer' : 'onelife_onetime',
                            '_offer_product_type' : 'primary',
                            _order_from : 'hybrid'
                        }
                    }
                ]
                };

                if (!bottleOOS) {
                    formData.items.push(
                        {
                            id: 53301741289656, // Free bottle variant ID
                            quantity: 1,
                            properties : {
                                '_offer' : 'onelife_onetime',
                                '_offer_product_type' : 'free',
                                _order_from : 'hybrid'
                            }
                        }
                    );
                }

                // if (!frotherOOS) {
                //     formData.items.push(
                //         {
                //             id: 52887363551416, // Free frother variant ID
                //             quantity: 1,
                //             properties : {
                //                 '_offer' : 'onelife_onetime',
                //                 '_offer_product_type' : 'free',
                //                 _order_from : 'hybrid'
                //             }
                //         }
                //     );
                // }


                // 1️⃣ Clear cart first
                // $.ajax({
                // type: 'POST',
                // url: '/cart/clear.js',
                //     success: function () {

                //         // 2️⃣ Add new items
                //         $.ajax({
                //         type: 'POST',
                //         url: '/cart/add.js',
                //         data: JSON.stringify(formData),
                //         dataType: 'json',
                //         contentType: 'application/json',
                //         success: function () {
                //             setTimeout(function(){
                //                 button.prop('disabled',false);
                //                 buttonTextEl.html(buttonTextValue);
                //             },2000);
                //             // 3️⃣ Redirect to checkout
                //             window.location.href = '/checkout';
                //         },
                //         error: function () {
                //             button.prop('disabled',false);
                //             buttonTextEl.html(buttonTextValue);
                //             alert('Could not add item to cart. Please try again.');
                //         }
                //         });

                //     },
                //     error: function () {
                //         button.prop('disabled',false);
                //         buttonTextEl.html(buttonTextValue);
                //         alert('Could not clear cart. Please try again.');
                //     }
                // });
                
                // 1️⃣ Check cart first
                $.getJSON('/cart.js', function(cart) {
                    const hasItems = cart.item_count > 0;

                    // 2️⃣ Add to cart
                    $.ajax({
                        type: 'POST',
                        url: '/cart/add.js',
                        data: JSON.stringify(formData),
                        dataType: 'json',
                        contentType: 'application/json',
                        success: function () {
                            
                            setTimeout(function(){
                                    button.prop('disabled',false);
                                    buttonTextEl.html(buttonTextValue);
                            },2000);

                            if (typeof FonCartDrawer !== "undefined") {
            FonCartDrawer.openCartDrawer();
            FonCartDrawer.updateCartDrawer();
          }
                        },
                        error: function () {
                            button.prop('disabled',false);
                            buttonTextEl.html(buttonTextValue);
                            alert('Could not add item to cart. Please try again.');
                        }
                    });
                });
                
            break;
        }

    });

    // $(window).on('load',function(){
    //     if ($(window).width() < 768) {
    //         $('.gift-product__card').removeClass('gift-product__card--active');
    //         $('.gift-product__card[data-tab="duo"]').addClass('gift-product__card--active');
    //         checkPerDay();
    //     }
    // });
    

    function showOutOfStockPopup(variantID){
      $.magnificPopup.open({
        items: {
          src: '#klaviyo-oos-' + variantID // This is the ID of the hidden div
        },
        type: 'inline'
      });
    }

    if (productOOS){
      showOutOfStockPopup('onelife');
    }

   


});